import * as types from '../constants/ActionTypes'



let receiveSessionTransfer = (sender, option, serviceRequestId, comments, customerUserId) => {
    return {
        type: types.RECEIVE_SESSION_TRANSFER,
        payload: {
            sender,
            option,
            serviceRequestId,
            comments,
            customerUserId
        }
    }
}

let receiveCancelSessionTransfer = (serviceRequestId) => {
    return {
        type: types.RECEIVE_CANCEL_SESSION_TRANSFER,
        payload: {
            serviceRequestId
        }
    }
}

let receiveSessionTransferResponse = (serviceRequestId, status) => {
    return {
        type: types.RECEIVE_SESSION_TRANSFER_RESPONSE,
        payload: {
            serviceRequestId,
            status
        }
    }
}

export default {
    receiveSessionTransfer,
    receiveCancelSessionTransfer,
    receiveSessionTransferResponse
}
